import React, { useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'react-headless-accordion';
import { IoIosArrowBack } from 'react-icons/io';

const Accordion3 = ({ type }) => {
    const [rotationState, setRotationState] = useState(false);

    const toggleRotation = () => {
        setRotationState(!rotationState);
    };

    const accordionTransitionDuration = 500; // Set the same duration as the accordion transition

    const accordionClass = () => {
        switch (type) {
            case 'rounded':
                return 'max-w-[500px] mx-auto border-accordionBorderColor bg-gradient-to-r from-green-700 to-green-500 rounded-2xl border-[4px] shadow-lg';
            case 'rectangle':
                return 'max-w-[500px] mx-auto border-accordionBorderColor rounded-none bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor border-[4px] shadow-lg';
            default:
                return '';
        }
    };

    return (
        <div className='mt-6 mx-auto px-4'>
            <Accordion
                className={accordionClass()}
                transition={{ duration: `${accordionTransitionDuration}ms`, timingFunction: 'cubic-bezier(0, 0, 0.2, 1)' }}
            >
                <AccordionItem>
                    <AccordionHeader
                        className='bg-gradient-to-r from-green-700 to-green-500 items-center text-accordion_headerColor flex p-4 w-full justify-between rounded-2xl'
                        onClick={toggleRotation}
                    >
                        <IoIosArrowBack
                            className={`${rotationState ? 'rotate-90' : ''} text-2xl text-accordion_iconColor`}
                            style={{ transition: `transform 0.5s ease-in-out` }}
                        />
                        <h3 dir='rtl' className='text-2xl font-bold'>האימון הירוק 🌴</h3>
                    </AccordionHeader>

                    <AccordionBody>
                        <div dir='rtl' className='text-accordionTextColor text-right font-medium p-4  rounded-b-2xl'>

                            <div>
                                <p className='mt-2 font-bold text-xl'>
                                    אימון בג'ונגל
                                </p>
                                <p dir='rtl'>
                                    ששם בפרונט את הכח המתפרץ , הכח והסבולת האן אירובית.
                                    דרך תבניות פונקציונליות ומרכיבים שבבסיסם באים לשפר את  התפקוד היום יומי שלך בפונקציות השונות  ואת הסבולת האן- אירובית של גופך.
                                </p>

                                <p className='mt-2 font-bold text-2xl'>
                                    הכח והסבולת האן אירובית
                                </p>
                                <div className='border-[1px] mt-2'>

                                </div>
                                <p className='mt-2 font-bold text-lg text-yellow-200'>
                                    סרטון האימון הירוק:
                                </p>

                            
                                <iframe
                                    src="https://www.youtube.com/embed/QpRvwdaaVeU"
                                    frameborder="0"
                                    height="350px"
                                    allow="autoplay; fullscreen"
                                    allowFullScreen
                                    style={{ borderRadius: '32px' }}
                                    className='my-4  w-full'
                                ></iframe>


                            </div>
                        </div>
                    </AccordionBody>
                </AccordionItem>
            </Accordion>
        </div>
    );
};

export default Accordion3;
